
import {createSlice} from "@reduxjs/toolkit";

export const financialSearchSlice = createSlice({
    name: 'financialSearchSlc',
    initialState: {value: {
                    fileId: null,
            propertyId: null,
            productName: null,
            episodeName: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seriesExternalId: null,
            seriesName: null,
            seasonExternalId: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            seasonName: null,
            account: null,
            amountFrom: null,
            amountTo: null,
            amountType: null,
            financialMarket: null,
            territory: null,
            languageCode: null,
            licenseId: null,
            licensee: null,
            periodEndDateFrom: null,
            periodEndDateTo: null,
            sourceSystem: null,
            sourceSystemId: null,
            unitsFrom: null,
            unitsTo: null,
            adjustBeginFrom: null,
            adjustBeginTo: null,
            adjustEndFrom: null,
            adjustEndTo: null,
            adjustNote: null,
            stakeholderId: null,
            contractId: null,
            participations: null,
            residuals: null,
            royalties: null,
            noSearchCriteria: false,

        }},
    reducers:

{
        changeFinancialSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeFinancialSearch } = financialSearchSlice.actions;

export default  financialSearchSlice.reducer ;
